/**
 * Provides simple in-memory application level cache for objects with expiry.
 */
export default class CachedObject<T> {
    private object: T | null = null;
    private updated: Date;
    private duration: number;

    /**
     * @param duration in milliseconds
     * @param object optional initial value
     */
    constructor(duration: number, object?: T) {
        this.duration = duration;
        this.updated = new Date('1970-01-01');

        if (object !== undefined) {
            this.update(object);
        }
    }

    isExpired() {
        return !this.object || new Date().getTime() - this.updated.getTime() >= this.duration;
    }

    isFresh() {
        return !this.isExpired();
    }

    update(object: T) {
        this.object = object;
        this.updated = new Date();
    }

    /**
     * Returns cached object or throws `Error` if cache is missing or expired.
     */
    get(): T {
        if (!this.object || this.isExpired()) {
            throw new Error('CachedObject expired or null');
        }

        return this.object;
    }
}
